<template>
  <footer class="footer">
        <div class="container d-flex justify-content-center align-items-center">
            <div>
                <span>Copyright &copy; 2026 Etilang Kemenhub</span>
            </div>
        </div>
    </footer>
</template>
  
  <script>
  export default {};
  </script>
  
  <style scoped>
  footer {
    position: relative;
    bottom: 0;
    width: 100%;
  }
  </style>
  